import * as React from 'react';
import { useApplicationContext } from '../../utils/applicationContext';
import { useSelector } from 'react-redux';
import { selectBuilderId } from '../../selectors/builder';
import { IOpenVillageBanner } from '../../types/banner';
import { OpenVillageBanner } from '../../components/OpenVillageBanner';
import { useDeviceType } from '@cian/ui-kit';

export const OpenVillageBannerContainer = () => {
  const builderId = useSelector(selectBuilderId);

  const { config } = useApplicationContext();
  const openVillageCompanyIds = config.get<number[]>('countryside.openVillage.companyIds') || [];
  const openVillageBanner = config.get<IOpenVillageBanner>('countryside.openVillage.cardBanner');
  const device = useDeviceType();

  if (!openVillageCompanyIds.includes(builderId) || !openVillageBanner) {
    return null;
  }

  return <OpenVillageBanner {...openVillageBanner} target={device === 'desktop' ? '_blank' : undefined} />;
};
